import { connect } from 'react-redux';
import PaymentSuccessPage from './PaymentSuccessPage';

const mapsStateToProps = state => ({});

const mapsDispatchToProps = dispatch => ({
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(PaymentSuccessPage);
